<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Adicionar Tipo de Unidade</div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action />
                  <div class="form-row">
                    <div class="col-md-6">
                      <label for="Name">
                        <span class="required">*</span> Nome:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control" v-model="tipo_unidade.nome"
                        placeholder="" />
                    </div>
                    <div class="col-md-6">
                      <label for="password">
                        <span class="required">*</span> Status:
                      </label>
                      <select v-model="tipo_unidade.status" class="form-control">
                        <option value="1">Ativo</option>
                        <option value="0">Inativo</option>
                      </select>
                    </div>
                  </div>
                  <hr>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong> Campos obrigatórios</strong>
                  </span>
                  <div class="form-group mt-1">
                    <div class="block text-right">
                      <router-link to="/tipo_unidades" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add ml-1" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      departments: [],
      change_password: true,
      tipo_unidade: {
        status: '1'
      },
      
      

      errors: undefined,

      previewImage: null,
    };
  },
  computed: {},
  methods: {

    save: function () {
      const self = this;
      let api = self.$store.state.api + "tipo_unidades";

      if (self.tipo_unidade.id) {
        self.tipo_unidade._method = "PUT"
        api += "/" + self.tipo_unidade.id;
      }

      axios
        .post(api, self.tipo_unidade)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/tipo_unidades");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.tipo_unidade.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.tipo_unidade.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.tipo_unidade.logradouro = self.endereco.logradouro;
            self.tipo_unidade.bairro = self.endereco.bairro;
            self.tipo_unidade.uf = self.endereco.uf;
            self.tipo_unidade.cidade = self.endereco.localidade;
            $("#inputNumero").focus();
          }
        );
      }
    },
    getTipoUnidade: function (id) {
      const self = this;
      const api = self.$store.state.api + "tipo_unidades/" + id;

      axios
        .get(api)
        .then((response) => {
          self.tipo_unidade = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  
  },
  mounted: function () {
    const self = this;
   
    let id = self.$route.params.id;
    if (id) {
      self.getTipoUnidade(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>